import { render } from "./ProductsDetail.vue?vue&type=template&id=0b03cb54"
import script from "./ProductsDetail.vue?vue&type=script&lang=js"
export * from "./ProductsDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__